type Value = string | number | boolean;

const parseValue = (value: string) => {
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  const numberValue = Number(value);
  if (!Number.isNaN(numberValue)) {
    return numberValue;
  }
  return value;
};

// transform searchParams to the object closely resembling query from react-router-v3
// for backwards-compatibility
export const searchParamsToObject = (searchParams: URLSearchParams) => {
  const object = Array.from(searchParams.entries()).reduce<
    Record<string, Value | Value[]>
  >((obj, [key, value]) => {
    const parsedValue = parseValue(value);

    if (obj[key] !== undefined) {
      if (Array.isArray(obj[key])) {
        (obj[key] as Value[]).push(parsedValue);
      } else {
        // eslint-disable-next-line no-param-reassign
        obj[key] = [obj[key] as Value, parsedValue];
      }
    } else {
      // eslint-disable-next-line no-param-reassign
      obj[key] = parsedValue;
    }
    return obj;
  }, {});

  return object;
};
